import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ContractDocument, ContractDocumentsError } from '../../types'

import ContractDocumentFileUploaderBlock from './ContractDocumentFileUploaderBlock'
import { Slide, ToastContainer } from 'react-toastify'

type Props = {
    theme: string
    contractAction: boolean
    contractGuid: string | undefined
    role: string
    onContractDocuments: (have_contract_documents: boolean) => void
    errors?: ContractDocumentsError
    // onAnyEdit: () => void
}

const ContractDocumentTable: React.FC<Props> = (props) => {
    const [contractDocuments, setContractDocuments] = useState<
        ContractDocument[] | null
    >(null)
    const [isLoadingContractDocuments, setLoadingContractDocuments] =
        useState(false)

    const [selectedItems, setSelectedItems] = useState<string[]>([])
    const [selectAll, setSelectAll] = useState<boolean>(false)

    const [isAttachment, setAttachment] = useState(true)

    const getContractDocuments = async (): Promise<ContractDocument[]> => {
        setLoadingContractDocuments(true)
        return fetch(
            `${process.env.REACT_APP_API_URL}/api/backend/v1/contract_attachments?contract_guid=${props.contractGuid}`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Ошибка запроса на документы')
                }
            })
            .catch((e) => {
                // console.error(e)
            })
            .finally(() => {
                setLoadingContractDocuments(false)
            })
    }

    // Функция для обработки изменения состояния отдельного checkbox
    const handleCheckboxChange = (perfDocument_guid: string) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(perfDocument_guid)) {
                return prevSelectedItems.filter(
                    (itemId) => itemId !== perfDocument_guid
                )
            } else {
                return [...prevSelectedItems, perfDocument_guid]
            }
        })
    }

    // Функция для обработки изменения состояния отдельного checkbox при нажатии правой кнопкой
    const handleRightClickCheckboxChange = (perfDocument_guid: string) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(perfDocument_guid)) {
                return prevSelectedItems // Если уже выбран, ничего не меняем
            }
            return [...prevSelectedItems, perfDocument_guid] // Добавляем в выбранные
        })
    }

    // Функция для обработки изменения состояния "Select All"
    const handleSelectAllChange = () => {
        setSelectAll(!selectAll)
        if (!selectAll) {
            // Выбираем только те элементы, которые соответствуют текущей стадии
            const filteredItems = contractDocuments
                ? contractDocuments.map((item) => item.guid)
                : []

            setSelectedItems(filteredItems)
        } else {
            // Сбрасываем выбор всех элементов
            setSelectedItems([])
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (props.contractGuid) {
                    const perfDocuments = await getContractDocuments()
                    if (perfDocuments) {
                        setContractDocuments(perfDocuments)
                    }
                }
            } catch (error) {
                console.error('Ошибка при загрузке данных:', error)
            }
        }
        fetchData()
    }, [])

    return (
        <fieldset disabled={false}>
            <div className="flex flex-col space-y-1 w-full items-center justify-start">
                <ContractDocumentFileUploaderBlock
                    theme={props.theme}
                    contractAction={props.contractAction}
                    contractGuid={String(props.contractGuid)}
                    isAttachment={isAttachment}
                    role={props.role}
                    onContractDocuments={props.onContractDocuments}
                    errors={props.errors}
                    // onAnyEdit={props.onAnyEdit}
                />

                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar
                    newestOnTop
                    closeOnClick
                    draggable
                    pauseOnHover
                    theme={props.theme == 'dark' ? 'dark' : 'light'}
                    transition={Slide}
                    className="!z-[9999]"
                    toastClassName={() =>
                        'flex w-fit min-h-[40px] px-3 py-2 items-center gap-2 bg-[#f6f6f6] dark:bg-[#2A282B] rounded-xl shadow-xl text-[#181818] dark:text-[#FFFFFF] text-[13px] my-1'
                    }
                />
            </div>
        </fieldset>
    )
}

export default ContractDocumentTable
